import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function FilesRequiredValidator(name): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let positiveResult = { name: true };
        const isvalid = control.value !== undefined && control.value != null
            && control.value != '' && control.value != ' ' && control.value != 'delete' && control.value != 'null'
        return !isvalid ? positiveResult : null;
    }
}

export function uniqueNameInFormArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Exit if control is not part of a form group or array
      if (!control.parent || !control.parent.parent) {
        return null;
      }
  
      // Ensure control is a FormControl within a FormGroup inside a FormArray
      const formArray = control.parent.parent;
      if (!formArray || !Array.isArray(formArray.controls)) {
        return null;
      }
  
      const currentName = control.value ? control.value.trim() : '';
      
      // Check for duplicates within the FormArray
      const isDuplicate = formArray.controls.some((group, index) => {
        // Skip checking the current group itself
        if (control.parent === group) {
          return false;
        }
        const name = group.get('filename')?.value?.trim() || '';
        return name === currentName;
      });
  
      return isDuplicate ? { duplicateName: true } : null;
    };
  }

//   export function uniqueNameAcrossArrayValidator(formArray: AbstractControl): ValidatorFn {
//     return (control: AbstractControl): ValidationErrors | null => {
//       // Ensure the control is inside a FormGroup and the parent is a FormArray
//       const parentArray = formArray as any;
//       if (!parentArray || !Array.isArray(parentArray.controls)) {
//         return null;
//       }
  
//       const currentName = control.value?.trim().toLowerCase(); // Trim and make it case-insensitive
  
//       if (!currentName) {
//         return null; // If name is empty, no need to check duplicates
//       }
  
//       let isDuplicate = false;
  
//       // Check for duplicates across all items in the FormArray
//       parentArray.controls.forEach((group: AbstractControl) => {
//         const nameControl = group.get('name');
//         if (nameControl && nameControl !== control) {
//           const name = nameControl.value?.trim().toLowerCase();
//           if (name === currentName) {
//             isDuplicate = true;
//           }
//         }
//       });
  
//       return isDuplicate ? { duplicateName: true } : null;
//     };
//   }

export function endDateValidator(control: AbstractControl): ValidationErrors | null {
  const startdt = control.parent?.get('startdt')?.value; // Access the start date
  const enddt = control.value; // Access the end date
  if (startdt && enddt && new Date(enddt) < new Date(startdt)) {
    return { min: true }; // Return error if end date is not greater than start date
  }

  return null; // Valid
}